const UNITS = ['KB', 'MB', 'GB', 'TB'];

// Anything under a kilobyte reads better unscaled, so it skips the loop entirely.
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;

  let size = bytes / 1024;
  let unit = 0;

  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024;
    unit += 1;
  }

  return `${size.toFixed(1)} ${UNITS[unit]}`;
}
